import { render } from "./XNoticeWayTip.vue?vue&type=template&id=027e7468&scoped=true"
import script from "./XNoticeWayTip.vue?vue&type=script&lang=js"
export * from "./XNoticeWayTip.vue?vue&type=script&lang=js"

import "./XNoticeWayTip.vue?vue&type=style&index=0&id=027e7468&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027e7468"]])

export default __exports__